import type { ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Text, Flex } from "@similarweb/ui-components/foundations";

interface ISettingSectionShellProps {
    title: string;
    field: ReactNode;
    children?: ReactNode;
}

export const SettingSectionShell = ({ title, field, children }: ISettingSectionShellProps) => (
    <Flex
        flexDirection="column"
        gap="8px"
    >
        <Flex
            flexDirection="column"
            gap="12px"
        >
            <Text
                fontVariant="subtitle2"
                color={colorsPalettes.carbon[400]}
            >
                {title}
            </Text>
            {field}
        </Flex>
        {children}
    </Flex>
);
